export default {
  bugReport: 'Bug report',
  descriptionPlaceholder: 'Describe the bug',
  attachments: 'Attachments',
  sendConfirmation: {
    summary: 'Bug report sent',
    detail: 'We have received your bug report and will contact you shortly.',
  },
};
